if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
      //  window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* ==========================================================================
   Kayza colour-filtered gallery (v3)

   Shows only the media matching the selected colour. Media whose alt text
   names no colour, or names more than one, is universal and always shown.
   A colour with fewer than MIN_MATCHES of its own falls back to the full
   gallery so it is never left near-empty.

   v3 fixes a blank main viewer when switching colour: the image the theme
   marks active could end up hidden by the filter, and the viewer's scroll
   offset was computed before filtering and left stale.

   To remove: delete everything below this comment. Nothing above it differs
   from the stock theme file.
   ========================================================================== */
(function () {
  'use strict';

  var HIDDEN_CLASS = 'kz-colour-hidden';
  var MIN_MATCHES = 2;

  function injectStyles() {
    if (document.getElementById('kz-colour-filter-styles')) return;
    var style = document.createElement('style');
    style.id = 'kz-colour-filter-styles';
    style.textContent = '.' + HIDDEN_CLASS + '{display:none !important;}';
    document.head.appendChild(style);
  }

  function toArray(n) { return Array.prototype.slice.call(n); }

  function getPicker() {
    return document.querySelector('variant-radios, variant-selects');
  }

  function getVariants(picker) {
    if (!picker) return null;
    var el = picker.querySelector('script[type="application/json"]');
    if (!el) return null;
    try {
      var p = JSON.parse(el.textContent);
      return Array.isArray(p) ? p : null;
    } catch (e) { return null; }
  }

  function viewerOf(g) { return g.querySelector('[id^="GalleryViewer"]'); }
  function thumbsOf(g) { return g.querySelector('[id^="GalleryThumbnails"]'); }

  function viewerItems(g) {
    var v = viewerOf(g);
    return v ? toArray(v.querySelectorAll('li[data-media-id]')) : [];
  }

  function thumbnailItems(g) {
    var t = thumbsOf(g);
    return t ? toArray(t.querySelectorAll('li[data-target]')) : [];
  }

  function itemAlt(li) {
    var img = li.querySelector('img[alt]');
    return img ? (img.getAttribute('alt') || '') : '';
  }

  function deriveColourOption(variants, alts) {
    var best = null;
    for (var pos = 1; pos <= 3; pos++) {
      var key = 'option' + pos;
      var values = [];
      for (var i = 0; i < variants.length; i++) {
        var raw = variants[i][key];
        if (typeof raw !== 'string') continue;
        var v = raw.trim().toLowerCase();
        if (v && values.indexOf(v) === -1) values.push(v);
      }
      if (values.length < 2) continue;
      var score = 0;
      for (var a = 0; a < alts.length; a++) {
        var text = alts[a].toLowerCase();
        for (var j = 0; j < values.length; j++) {
          if (values[j].length < 3) continue;
          if (text.indexOf(values[j]) !== -1) score++;
        }
      }
      if (score > 0 && (!best || score > best.score)) {
        best = { position: pos, values: values, score: score };
      }
    }
    return best;
  }

  function getSelectedColour(picker, option, variants) {
    var i;
    var checked = picker.querySelectorAll('input[type="radio"]:checked');
    for (i = 0; i < checked.length; i++) {
      var v = (checked[i].value || '').trim().toLowerCase();
      if (option.values.indexOf(v) !== -1) return v;
    }
    var selects = picker.querySelectorAll('select');
    for (i = 0; i < selects.length; i++) {
      var sv = (selects[i].value || '').trim().toLowerCase();
      if (option.values.indexOf(sv) !== -1) return sv;
    }
    try {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (id) {
        for (i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) {
            var val = variants[i]['option' + option.position];
            if (typeof val === 'string') return val.trim().toLowerCase();
          }
        }
      }
    } catch (e) { /* no URLSearchParams */ }
    return null;
  }

  function colourForAlt(alt, values) {
    var a = (alt || '').toLowerCase();
    var found = [];
    for (var i = 0; i < values.length; i++) {
      if (a.indexOf(values[i]) !== -1) found.push(values[i]);
    }
    return found.length === 1 ? found[0] : 'universal';
  }

  function updateCounter(g) {
    var v = viewerOf(g);
    if (!v) return;
    var visible = v.querySelectorAll('li[data-media-id]:not(.' + HIDDEN_CLASS + ')').length;
    var total = g.querySelector('.slider-counter--total');
    if (total) total.textContent = visible;
  }

  function normaliseActive(g) {
    var v = viewerOf(g);
    if (!v) return;

    var all = viewerItems(g);
    var visible = all.filter(function (li) {
      return !li.classList.contains(HIDDEN_CLASS);
    });
    if (!visible.length) return;

    var active = null;
    for (var i = 0; i < visible.length; i++) {
      if (visible[i].classList.contains('is-active')) { active = visible[i]; break; }
    }

    if (!active) {
      all.forEach(function (li) { li.classList.remove('is-active'); });
      active = visible[0];
      active.classList.add('is-active');

      var t = thumbsOf(g);
      if (t) {
        toArray(t.querySelectorAll('button')).forEach(function (b) {
          b.removeAttribute('aria-current');
        });
        var match = t.querySelector(
          'li[data-target="' + active.dataset.mediaId + '"] button'
        );
        if (match) match.setAttribute('aria-current', 'true');
      }
    }

    var list = active.parentElement;
    var settle = function () {
      try {
        if (list && typeof list.scrollTo === 'function') {
          list.scrollTo({ left: active.offsetLeft, behavior: 'auto' });
        }
      } catch (e) { /* no scrollTo */ }
      if (typeof v.resetPages === 'function') {
        try { v.resetPages(); } catch (e) { /* slider not ready */ }
      }
    };

    window.requestAnimationFrame(settle);
    window.setTimeout(settle, 120);
    window.setTimeout(settle, 400);
  }

  function applyToGallery(g, selected, values) {
    var items = viewerItems(g).concat(thumbnailItems(g));
    if (!items.length) return;

    items.forEach(function (li) {
      if (!li.dataset.kzColour) {
        li.dataset.kzColour = colourForAlt(itemAlt(li), values);
      }
    });

    var matches = viewerItems(g).filter(function (li) {
      return li.dataset.kzColour === selected;
    }).length;

    var enabled = !!selected && matches >= MIN_MATCHES;

    items.forEach(function (li) {
      var c = li.dataset.kzColour;
      li.classList.toggle(
        HIDDEN_CLASS,
        enabled && c !== 'universal' && c !== selected
      );
    });

    updateCounter(g);
    normaliseActive(g);
  }

  function run() {
    injectStyles();
    var picker = getPicker();
    if (!picker) return;

    var galleries = toArray(document.querySelectorAll('media-gallery'));
    if (!galleries.length) return;

    var variants = getVariants(picker);
    if (!variants || !variants.length) return;

    var alts = [];
    galleries.forEach(function (g) {
      viewerItems(g).forEach(function (li) { alts.push(itemAlt(li)); });
    });
    if (!alts.length) return;

    var option = deriveColourOption(variants, alts);
    if (!option) return;

    var selected = getSelectedColour(picker, option, variants);
    galleries.forEach(function (g) {
      applyToGallery(g, selected, option.values);
    });
  }

  function schedule() {
    window.requestAnimationFrame(function () { window.setTimeout(run, 0); });
    window.setTimeout(run, 150);
    window.setTimeout(run, 450);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    if (t.closest('variant-radios, variant-selects')) schedule();
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    if (t.closest('variant-radios, variant-selects')) schedule();
  });

  try {
    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS === 'object' &&
        PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, schedule);
    }
  } catch (e) { /* pubsub unavailable */ }
})();
